/**
 * Pure helper functions for ModalChangePlan.
 * Extracted to a separate .ts file so specs can import them without hitting
 * the Vue SFC boundary (shims-vue.d.ts only declares default exports).
 */

export const isSubmitDisabled = (
  isSubmitting: boolean,
  isShowMsg: boolean,
  reMonshin: boolean | null,
): boolean => isSubmitting || !isShowMsg || reMonshin === null;

export const buildPlanChangePayload = (
  planId: number | null,
  reMonshin: boolean | null,
) => ({ plan_id: planId, re_monshin: reMonshin });
